import '@fontsource-variable/roboto-flex/index.css';
import './styles/tokens.css';
import './styles/app.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { createServices } from './app/createServices';
import { PwaUpdater } from './app/PwaUpdater';

const services = createServices();

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');

createRoot(root).render(
  <StrictMode>
    <App services={services} />
    <PwaUpdater />
  </StrictMode>,
);

// Ask the browser to keep IndexedDB data (offline notes) under storage pressure.
if ('storage' in navigator && 'persist' in navigator.storage) void navigator.storage.persist();
